import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { TicketSubject }    from "Utils/API";



// The initial State
const initialState = {
    loading     : true,
    error       : false,
    edition     : 0,
    canCreate   : false,
    canEdit     : false,
    canFilter   : false,
    canImport   : false,
    canExport   : false,
    list        : [],
    total       : 0,
    elem        : {},
    areas       : [],
    departments : {},
    statuses    : [],
    sort        : {
        orderBy  : "mainPosition",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "TICKET_SUBJECT_LOADING" });
    },

    /**
     * Fetches the Ticket Subject List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await TicketSubject.getAll(params);
        data.sort = params;
        dispatch({ type : "TICKET_SUBJECT_LIST", data });
    },

    /**
     * Fetches a single Ticket Subject
     * @param {Function} dispatch
     * @param {Number}   ticketSubjectID
     * @returns {Promise}
     */
    async fetchElem(dispatch, ticketSubjectID) {
        const data = await TicketSubject.getOne({ ticketSubjectID });
        dispatch({ type : "TICKET_SUBJECT_ELEM", data });
    },

    /**
     * Fetches the Ticket Subject Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await TicketSubject.getEditData();
        dispatch({ type : "TICKET_SUBJECT_EDIT", data });
    },

    /**
     * Edits a Ticket Subject
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return TicketSubject.edit(data);
    },

    /**
     * Deletes a Ticket Subject
     * @param {Function} dispatch
     * @param {Number}   ticketSubjectID
     * @returns {Promise}
     */
    deleteElem(dispatch, ticketSubjectID) {
        return TicketSubject.delete({ ticketSubjectID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "TICKET_SUBJECT_LIST", "TICKET_SUBJECT_ELEM", "TICKET_SUBJECT_EDIT")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "TICKET_SUBJECT_LOADING":
        return {
            ...state,
            loading     : true,
        };

    case "TICKET_SUBJECT_LIST":
        return {
            ...state,
            loading     : false,
            error       : false,
            canCreate   : action.data.canCreate,
            canEdit     : action.data.canEdit,
            canFilter   : action.data.canFilter,
            canImport   : action.data.canImport,
            canExport   : action.data.canExport,
            list        : action.data.list,
            total       : action.data.total,
            sort        : action.data.sort,
        };

    case "TICKET_SUBJECT_ELEM":
        return {
            ...state,
            error       : false,
            edition     : state.edition + 1,
            elem        : action.data.elem,
            areas       : action.data.areas,
            departments : action.data.departments,
            statuses    : action.data.statuses,
        };

    case "TICKET_SUBJECT_EDIT":
        return {
            ...state,
            error       : false,
            edition     : state.edition + 1,
            areas       : action.data.areas,
            departments : action.data.departments,
            statuses    : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
